// Google Data Layer
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
console.log("window.dataLayer via [Consent Manager] initialized.");

if (window.location.pathname.includes('/products/')) {
  //Skript fuer SKU Aktualisierung
document.addEventListener('DOMContentLoaded', function () {
        const variantPicker = document.querySelector('.product-information .variant-picker');
        const skuOutput = document.getElementById('variant-sku');
        const productJsonScript = document.getElementById('main-product-page-json');

        if (!variantPicker || !skuOutput || !productJsonScript) return;

        const productData = JSON.parse(productJsonScript.textContent);
        const variants = productData.variants;
        const productOptions = productData.options;
        const selectedOptions = {};

        function updateSelectedOptions() {
            const radios = variantPicker.querySelectorAll('input.product-variant-radio[type="radio"]');
            radios.forEach(radio => {
                if (radio.checked) {
                    selectedOptions[radio.name] = radio.value;
                }
            });
        }

        function findMatchingVariant() {
            return variants.find(variant => {
                return productOptions.every((optionName, index) => {
                    return variant[`option${index + 1}`] === selectedOptions[optionName];
                });
            });
        }

        function updateSKU() {
          updateSelectedOptions();
          const matchingVariant = findMatchingVariant();
          const skuValueElement = skuOutput.querySelector('.sku-value');
      
          if (!skuValueElement) return;
      
          if (matchingVariant && matchingVariant.sku) {
              skuValueElement.textContent = matchingVariant.sku;
          } else {
              skuValueElement.textContent = '–';
          }
      }


        // Initialer Aufruf
        updateSKU();

        // MutationObserver zur Überwachung von Änderungen in der Varianten-Auswahl
        const observer = new MutationObserver(mutations => {
            let relevantChange = false;

            mutations.forEach(mutation => {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'checked' &&
                    mutation.target.matches('input.product-variant-radio')
                ) {
                    relevantChange = true;
                }
            });

            if (relevantChange) {
                updateSKU();
            }
        });

        // Observer auf alle Radio-Inputs anwenden
        const observeRadios = () => {
            const radios = variantPicker.querySelectorAll('input.product-variant-radio[type="radio"]');
            radios.forEach(radio => {
                observer.observe(radio, { attributes: true });
            });
        };

        observeRadios(); // Start beobachten

        // Optional: Re-Initialisierung bei DOM-Wechsel (falls Varianten-DOM dynamisch ersetzt wird)
        const domObserver = new MutationObserver(() => {
            observer.disconnect();
            observeRadios();
            updateSKU();
        });

        domObserver.observe(variantPicker, { childList: true, subtree: true });
    });

}